import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import {  withStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import core from "assets/img/ic-CORE.png";
import los from "assets/img/ic-CAS.png";
import lms from "assets/img/ic-LMS.png";
import { Grid } from "@material-ui/core";
import ToastModal from "views/components/ToastModal";
import { designation } from "assets/properties/properties";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { parseAndSetFlag } from "utils/Utils";
const style = () => ({
  moduleSectionContianer: {
    margin: 5,
    width: 295,
    padding: 20,
    display: "block",
    textAlign: "center",
    backgroundColor: module.color,
    height:160,
    borderRadius: 25,
    borderWidth: 2,
    transition:'0.5s',
    borderStyle: "solid",
    cursor:'pointer',
    '&:hover':{
      transform:"scale(1.1)",
      transition:'0.5s',
      margin:'0px 20px',
    }
  },
  modules:{
    display:'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent:'center',
  }
})

const ModuleSelection = ({ classes }) => {
  const navigate = useNavigate();
  const outletData = useOutletContext();
  const { authToken } = useSelector((state) => state.login.authData);
  const { email, name } = useSelector(
    (state) => state.login.userData
  );
  const [moduleData, setModuleData] = useState({});
  const [redirectURL, setRedirectURL] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [showTabsAsPerTheDesignationFlag, setShowTabsAsPerTheDesignationFlag] =
    useState(false);
  const [showPersonalLoanEnableFlag, setShowPersonalLoanEnableFlag] = useState(false);
  const [isModulesLoaded, setIsModulesLoaded] = useState(false);
  const [disabledModules, setDisabledModules] = useState({
    core: false,
    los: false,
    lms: false,
  });

  const moduleList = useMemo(
    () => [
      {
        imageName: core,
        nameHeading: "CORE",
        namesubtitle: "Master List",
        name: "open Module",
        module: "core",
      },

      {
        imageName: los,
        nameHeading: "LOS",
        namesubtitle: "For Faster Customer Acquisition",
        name: "open Module",
        module: "los",
      },
      {
        imageName: los,
        nameHeading: "Personal Loan LOS",
        namesubtitle:"For Faster Customer Acquisition",
        name: "open Module",
        module: "personalLoanLos",
      },
      {
        imageName: lms,
        nameHeading: "LMS",
        namesubtitle: "Next Generation Loan Servicing",
        name: "open Module",
        module: "lms",
      },
    ],
    []
  );
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type)
    setToastMessage(message)
    setToast(showToast)
    if (redirectURL !== "") {
      navigate(redirectURL);
      setRedirectURL("");
    }
  };
  useEffect(() => {
    getOtherAppsUrl();
  }, [authToken]);
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getOtherAppsUrl = async () => {
    const result = await apiHandler({
      url: endpoint.APP_URL,
    });
    setModuleData(result.data);
  };
  const flag = (val) =>
    typeof val === "boolean" ? val : val === "true";

  const getFeatureFlag = async () => {
    try {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.FEATURE_FLAG,
      });

      const designationOrRoleBased = flag(
        result?.data?.showTabsAsPerTheDesignationFlag
      );
      setShowTabsAsPerTheDesignationFlag( designationOrRoleBased);
      setShowPersonalLoanEnableFlag(parseAndSetFlag(result?.data?.personalLoanFlag));
      await getUserDetails(designationOrRoleBased);
    } catch (error) {
      setIsModulesLoaded(true);
    } finally {
      setCallInProgress(false);
    }
  };

   const getUserDetails = async (designationOrRoleBased) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if(result?.data?.error_code){
      toastUpdate("Error",result?.data?.user_description,true);
    }else{
      const finalUser =
  result?.data?.role === "role_checker" &&
  !result?.data?.rootHierarchy
    ? "role_branch_checker"
    : result?.data?.role;
      const searchParam = designationOrRoleBased
        ? result?.data?.designation
        : finalUser;
      setUserDetails(result?.data)
      await getRestrictions(searchParam, designationOrRoleBased);
    }
  };

  const getRestrictions = async (
    searchParam,
    designationOrRoleBased,
  ) => {
    try {
      setCallInProgress(true);
      const query = designationOrRoleBased
        ? `designation=${searchParam}`
        : `role=${searchParam}`;
      const result = await apiHandler({
        url: endpoint.UI_RESTRICTION_FIND + query,
        authToken: authToken,
      });
      if (
        result?.data?.error_code ||
        result?.data?.user_description ||
        !result?.data?.restrictions
      ) {
        setDisabledModules({
          core: false,
          los: false,
          lms: false,
        });
      } else {
        const disabledModuleData = JSON.parse(
          result?.data?.restrictions
        );
        setDisabledModules({
          core:disabledModuleData?.disabledModule?.core || false,
          los:disabledModuleData?.disabledModule?.los || false,
          lms:disabledModuleData?.disabledModule?.lms || false,
        });
      }
    } catch (error) {
      setDisabledModules({
        core: false,
        los: false,
        lms: false,
      });
    } finally {
      setCallInProgress(false);
      setIsModulesLoaded(true);
    }
  };
  const openModule = async (module) => {
    const result = await apiHandler({
      url: endpoint.RETAIN_TOKEN,
      method: "POST",
      authToken: authToken,
      data: {
        username: email,
        accessToken: authToken,
      },
    });
    console.log(result.data);
    if (result.data.error_code) {
      toastUpdate("Error", result?.data?.user_description, true)
      setRedirectURL('/home/login');
    } else {
      const URL = moduleData[module.module] + "/auto/" + result.data.uuid;
      window.open(URL);
    }
  };

  const shouldShowModule = (module) => {
    if (module.nameHeading === "CORE") {
      return (
        !disabledModules.core ||
        (disabledModules.core &&
          !showTabsAsPerTheDesignationFlag &&
          userDetails?.rootHierarchy)
      );
    }
    if (module.nameHeading === "LOS" && !showPersonalLoanEnableFlag) {
      return !disabledModules.los;
    }
    if(module.nameHeading === "Personal Loan LOS" && showPersonalLoanEnableFlag){
      return !disabledModules.los;
    }
    if (module.nameHeading === "LMS") {
      return !disabledModules.lms;
    }
    return false;
  };

  const getModuleList = () => {
    return moduleList?.map((module, index) => {
      if (!shouldShowModule(module)) {
        return null;
      }
          return (
            <div
              key={index}
              className={classes.moduleSectionContianer}
    
              onClick={() => openModule(module)}
            >
              <div>
                <img
                  src={module.imageName}
                  alt="module logo"
                />
              </div>
              <div>
                {" "}
                <div
                  style={{
                    // fontWeight: 300,
                    lineHeight: "1.5em",
                    fontSize: "1.5em",
                    fontFamily: "arial-black",
                    fontWeight: "bold",
                  }}
                >
                  <span>{module.nameHeading}</span>
                </div>{" "}
              </div>

              <div style={{ marginBottom: 20 }}>
                <span>{module.namesubtitle}</span>
              </div>
            </div>
          
      );
    });
  };
  return (
    <div>
      {userDetails && Object?.keys(userDetails)?.length > 0  && isModulesLoaded && 
      <Grid justify="center">
        <Grid>
          <Grid xs={12} sm={12} md={12} style={{ textAlign: "center" }}>
            <div style={{ fontWeight: 200, margin: 35, fontSize: 24 }}>
              <b>Welcome!</b>{" "}
              <span style={{ fontWeight: "bold" }}>{name}</span> <b>to</b>{" "}
              <b> DIGIRINN </b>
            </div>
          </Grid>
        </Grid>
        {/* <hr></hr> */}
        <Grid>
          <Grid
            xs={12}
            sm={12}
            md={12}
            style={{
              textAlign: "center",
              marginTop: "40px",
            }}
            className={classes.modules}
          >
            {getModuleList()}

          </Grid>
        </Grid>
      </Grid>}
      {toast && (
              <ToastModal
              toastMessage={toastMessage} 
              toastMessageType={toastMessageType} 
              toastUpdate={toastUpdate}
        />
        )}
        {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
}

export default withStyles(style)(ModuleSelection);